/**
 * PixelBlock Python to Blocks Parser.
 * Parses Python code into ScratchBlocks blocks and arranges them on the workspace.
 */

function ensureWorkspaceVariable(workspace, name) {
    if (!workspace || !name) return null;
    const cleanName = String(name).trim();
    if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(cleanName)) return null;
    const varMap = typeof workspace.getVariableMap === 'function' ? workspace.getVariableMap() : null;
    let v = null;
    if (varMap && typeof varMap.getVariable === 'function') {
        v = varMap.getVariable(cleanName, '');
    } else if (typeof workspace.getVariable === 'function') {
        v = workspace.getVariable(cleanName, '');
    }
    if (!v) {
        if (varMap && typeof varMap.createVariable === 'function') {
            v = varMap.createVariable(cleanName, '');
        } else if (typeof workspace.createVariable === 'function') {
            v = workspace.createVariable(cleanName, '');
        }
    }
    return v;
}

function setVariableField(workspace, block, fieldName, varName) {
    if (!block || !varName) return;
    const cleanName = String(varName).trim();
    if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(cleanName)) return;
    const varModel = ensureWorkspaceVariable(workspace, cleanName);
    const field = block.getField(fieldName);
    if (field) {
        if (varModel && typeof field.setValue === 'function') {
            field.setValue(varModel.getId());
        } else if (typeof block.setFieldValue === 'function') {
            block.setFieldValue(cleanName, fieldName);
        }
    } else if (typeof block.setFieldValue === 'function') {
        block.setFieldValue(cleanName, fieldName);
    }
}

function getDefaultShadowSpec(blockType, inputName) {
    if (
        (blockType === 'python_print' && (inputName === 'TEXT' || /^TEXT\d+$/.test(inputName))) ||
        (blockType === 'python_while' && inputName === 'CONDITION') ||
        (blockType === 'python_for_in' && inputName === 'LIST') ||
        (blockType === 'python_input' && inputName === 'PROMPT') ||
        (blockType === 'python_input_int' && inputName === 'PROMPT') ||
        (blockType === 'python_input_float' && inputName === 'PROMPT') ||
        (blockType === 'python_cast_int' && inputName === 'VAL') ||
        (blockType === 'python_cast_float' && inputName === 'VAL') ||
        (blockType === 'python_type' && inputName === 'VAL') ||
        (blockType === 'python_bool_op' && (inputName === 'A' || inputName === 'B')) ||
        (blockType === 'python_not' && inputName === 'A') ||
        (blockType === 'python_return' && inputName === 'VAL') ||
        (blockType === 'python_turtle_color' && inputName === 'COLOR') ||
        (blockType === 'python_list_append' && inputName === 'LIST') ||
        (blockType === 'python_list_pop' && inputName === 'LIST') ||
        (blockType === 'python_list_remove' && inputName === 'LIST') ||
        (blockType === 'python_list_insert' && (inputName === 'LIST' || inputName === 'ITEM')) ||
        (blockType === 'python_list_get' && inputName === 'LIST') ||
        (blockType === 'python_list_set' && inputName === 'LIST') ||
        (blockType === 'python_list_len' && inputName === 'LIST') ||
        (blockType === 'python_dict_get' && (inputName === 'DICT' || inputName === 'KEY')) ||
        (blockType === 'python_dict_set' && (inputName === 'DICT' || inputName === 'KEY' || inputName === 'VAL')) ||
        (blockType === 'python_dict_keys' && inputName === 'DICT') ||
        (blockType === 'python_dict_values' && inputName === 'DICT')
    ) {
        let defaultText = '';
        if (blockType === 'python_cast_int') defaultText = '123';
        else if (blockType === 'python_cast_float') defaultText = '3.14';
        else if (blockType === 'python_type') defaultText = 'x';
        else if (blockType === 'python_turtle_color') defaultText = 'black';
        else if (blockType === 'python_list_insert' && inputName === 'ITEM') defaultText = 'item';
        else if (inputName === 'KEY') defaultText = 'key';
        else if (inputName === 'VAL') defaultText = 'val';

        return {
            type: 'text',
            fields: { TEXT: defaultText }
        };
    }

    if (
        (blockType === 'python_variable_set' && inputName === 'VALUE') ||
        (blockType === 'python_variable_change' && inputName === 'VALUE') ||
        (blockType === 'python_for_range' && (inputName === 'START' || inputName === 'STOP')) ||
        (blockType === 'python_for_range_step' && (inputName === 'START' || inputName === 'STOP' || inputName === 'STEP')) ||
        (blockType === 'python_cast_str' && inputName === 'VAL') ||
        (blockType === 'python_cast_bool' && inputName === 'VAL') ||
        (blockType === 'python_arithmetic' && (inputName === 'A' || inputName === 'B')) ||
        (blockType === 'python_round' && inputName === 'NUM') ||
        (blockType === 'python_abs' && inputName === 'NUM') ||
        (blockType === 'python_min_max' && (inputName === 'A' || inputName === 'B')) ||
        (blockType === 'python_unary' && inputName === 'NUM') ||
        (blockType === 'python_compare' && (inputName === 'A' || inputName === 'B')) ||
        (blockType === 'python_list_create_3' && (inputName === 'A' || inputName === 'B' || inputName === 'C')) ||
        (blockType === 'python_list_create_4' && (inputName === 'A' || inputName === 'B' || inputName === 'C' || inputName === 'D')) ||
        (blockType === 'python_list_create_5' && (inputName === 'A' || inputName === 'B' || inputName === 'C' || inputName === 'D' || inputName === 'E')) ||
        (blockType === 'python_list_append' && inputName === 'ITEM') ||
        (blockType === 'python_list_remove' && inputName === 'ITEM') ||
        (blockType === 'python_list_pop' && inputName === 'INDEX') ||
        (blockType === 'python_list_insert' && inputName === 'INDEX') ||
        (blockType === 'python_list_get' && inputName === 'INDEX') ||
        (blockType === 'python_list_set' && (inputName === 'INDEX' || inputName === 'VALUE')) ||
        (blockType === 'python_range' && inputName === 'STOP') ||
        (blockType === 'python_range_start_stop' && (inputName === 'START' || inputName === 'STOP')) ||
        (blockType === 'python_turtle_forward' && inputName === 'DIST') ||
        (blockType === 'python_turtle_backward' && inputName === 'DIST') ||
        (blockType === 'python_turtle_right' && inputName === 'ANGLE') ||
        (blockType === 'python_turtle_left' && inputName === 'ANGLE') ||
        (blockType === 'python_turtle_goto' && (inputName === 'X' || inputName === 'Y')) ||
        (blockType === 'python_turtle_setheading' && inputName === 'ANGLE') ||
        (blockType === 'python_turtle_width' && inputName === 'SIZE') ||
        (blockType === 'python_turtle_circle' && inputName === 'RADIUS') ||
        (blockType === 'python_turtle_speed' && inputName === 'SPEED')
    ) {
        let defaultNum = 0;
        if (blockType === 'python_variable_change') defaultNum = 1;
        else if (blockType === 'python_for_range' && inputName === 'STOP') defaultNum = 10;
        else if (blockType === 'python_for_range_step' && inputName === 'STOP') defaultNum = 10;
        else if (blockType === 'python_for_range_step' && inputName === 'STEP') defaultNum = 1;
        else if (blockType === 'python_cast_str') defaultNum = 42;
        else if (blockType === 'python_cast_bool') defaultNum = 1;
        else if (blockType === 'python_arithmetic') defaultNum = 1;
        else if (blockType === 'python_round') defaultNum = 3.14;
        else if (blockType === 'python_abs') defaultNum = -5;
        else if (blockType === 'python_min_max' && inputName === 'A') defaultNum = 10;
        else if (blockType === 'python_min_max' && inputName === 'B') defaultNum = 20;
        else if (blockType === 'python_unary') defaultNum = 1;
        else if (blockType === 'python_list_create_3') {
            if (inputName === 'A') defaultNum = 1;
            else if (inputName === 'B') defaultNum = 2;
            else if (inputName === 'C') defaultNum = 3;
        } else if (blockType === 'python_list_create_4') {
            if (inputName === 'A') defaultNum = 1;
            else if (inputName === 'B') defaultNum = 2;
            else if (inputName === 'C') defaultNum = 3;
            else if (inputName === 'D') defaultNum = 4;
        } else if (blockType === 'python_list_create_5') {
            if (inputName === 'A') defaultNum = 1;
            else if (inputName === 'B') defaultNum = 2;
            else if (inputName === 'C') defaultNum = 3;
            else if (inputName === 'D') defaultNum = 4;
            else if (inputName === 'E') defaultNum = 5;
        } else if (blockType === 'python_list_append' && inputName === 'ITEM') defaultNum = 10;
        else if (blockType === 'python_list_remove' && inputName === 'ITEM') defaultNum = 10;
        else if (blockType === 'python_list_set' && inputName === 'VALUE') defaultNum = 99;
        else if (blockType === 'python_range' && inputName === 'STOP') defaultNum = 10;
        else if (blockType === 'python_range_start_stop') {
            if (inputName === 'START') defaultNum = 1;
            else if (inputName === 'STOP') defaultNum = 11;
        } else if (blockType === 'python_turtle_forward' || blockType === 'python_turtle_backward') defaultNum = 100;
        else if (blockType === 'python_turtle_right' || blockType === 'python_turtle_left') defaultNum = 90;
        else if (blockType === 'python_turtle_width') defaultNum = 1;
        else if (blockType === 'python_turtle_circle') defaultNum = 50;
        else if (blockType === 'python_turtle_speed') defaultNum = 6;

        return {
            type: 'math_number',
            fields: { NUM: defaultNum }
        };
    }

    if (!inputName.startsWith('CONDITION') && !inputName.startsWith('SUBSTACK')) {
        return {
            type: 'text',
            fields: { TEXT: '' }
        };
    }

    return null;
}

function attachDefaultShadows(block) {
    if (!block || !block.inputList) return;
    for (const input of block.inputList) {
        if (!input.connection) continue;
        const isValueInput = input.type === 1 || (typeof ScratchBlocks !== 'undefined' && input.type === ScratchBlocks.INPUT_VALUE);
        if (!isValueInput) continue;

        const target = typeof input.connection.targetBlock === 'function' ? input.connection.targetBlock() : null;
        if (target && typeof target.isShadow === 'function' && target.isShadow()) {
            continue;
        }

        const spec = getDefaultShadowSpec(block.type, input.name);
        if (spec && typeof input.connection.setShadowState === 'function') {
            try {
                input.connection.setShadowState(spec);
            } catch (e) {
                console.warn('Error setting shadow state:', e);
            }
        }
    }
}

function createBlock(workspace, type, opt_fields) {
    if (!workspace || !workspace.newBlock) return null;
    const block = workspace.newBlock(type);
    if (block) {
        if (opt_fields) {
            for (const key of Object.keys(opt_fields)) {
                const val = opt_fields[key];
                if (key === 'VAR' && (type === 'python_variable_set' || type === 'python_variable_change' || type === 'python_variable_get')) {
                    setVariableField(workspace, block, 'VAR', val);
                } else if (typeof block.setFieldValue === 'function') {
                    block.setFieldValue(val, key);
                }
            }
        }
        if (type === 'math_number' || type === 'text') {
            if (typeof block.setShadow === 'function') {
                block.setShadow(true);
            }
        }
        if (typeof block.initSvg === 'function') {
            block.initSvg();
        } else if (typeof block.initModel === 'function') {
            block.initModel();
        }
    }
    return block;
}

function splitArguments(argStr) {
    if (!argStr || !argStr.trim()) return [];
    const args = [];
    let current = '';
    let inSingleQuote = false;
    let inDoubleQuote = false;
    let parenDepth = 0;
    let bracketDepth = 0;
    let braceDepth = 0;
    let escape = false;

    for (let i = 0; i < argStr.length; i++) {
        const c = argStr[i];

        if (escape) {
            current += c;
            escape = false;
            continue;
        }

        if (c === '\\') {
            current += c;
            escape = true;
            continue;
        }

        if (c === "'" && !inDoubleQuote) {
            inSingleQuote = !inSingleQuote;
            current += c;
        } else if (c === '"' && !inSingleQuote) {
            inDoubleQuote = !inDoubleQuote;
            current += c;
        } else if (!inSingleQuote && !inDoubleQuote) {
            if (c === '(') parenDepth++;
            else if (c === ')') parenDepth--;
            else if (c === '[') bracketDepth++;
            else if (c === ']') bracketDepth--;
            else if (c === '{') braceDepth++;
            else if (c === '}') braceDepth--;
            else if (c === ',' && parenDepth === 0 && bracketDepth === 0 && braceDepth === 0) {
                args.push(current.trim());
                current = '';
                continue;
            }
            current += c;
        } else {
            current += c;
        }
    }

    if (current.trim()) {
        args.push(current.trim());
    }

    return args;
}

function unwrapOuterParens(str) {
    let s = str.trim();
    while (s.startsWith('(') && s.endsWith(')')) {
        let depth = 0;
        let matched = true;
        for (let i = 0; i < s.length - 1; i++) {
            if (s[i] === '(') depth++;
            else if (s[i] === ')') depth--;
            if (depth === 0) {
                matched = false;
                break;
            }
        }
        if (matched) {
            s = s.substring(1, s.length - 1).trim();
        } else {
            break;
        }
    }
    return s;
}

function parseFuncCall(name, str) {
    const prefix = name + '(';
    if (str.startsWith(prefix) && str.endsWith(')')) {
        let depth = 0;
        for (let i = prefix.length - 1; i < str.length - 1; i++) {
            if (str[i] === '(') depth++;
            else if (str[i] === ')') depth--;
            if (depth === 0) return null;
        }
        return str.substring(prefix.length, str.length - 1).trim();
    }
    return null;
}

function findTopLevelBinaryOp(expr) {
    const trimmed = expr.trim();
    if (!trimmed) return null;

    const opGroups = [
        ['or'],
        ['and'],
        ['==', '!=', '<=', '>=', '<', '>'],
        ['+', '-'],
        ['//', '%', '*', '/'],
        ['**']
    ];

    for (const group of opGroups) {
        let inSingleQuote = false;
        let inDoubleQuote = false;
        let parenDepth = 0;
        let bracketDepth = 0;
        let braceDepth = 0;

        for (let i = trimmed.length - 1; i >= 0; i--) {
            const char = trimmed[i];
            const prev = i > 0 ? trimmed[i - 1] : '';

            if (char === "'" && !inDoubleQuote && prev !== '\\') {
                inSingleQuote = !inSingleQuote;
            } else if (char === '"' && !inSingleQuote && prev !== '\\') {
                inDoubleQuote = !inDoubleQuote;
            } else if (!inSingleQuote && !inDoubleQuote) {
                if (char === ')') parenDepth++;
                else if (char === '(') parenDepth--;
                else if (char === ']') bracketDepth++;
                else if (char === '[') bracketDepth--;
                else if (char === '}') braceDepth++;
                else if (char === '{') braceDepth--;
                else if (parenDepth === 0 && bracketDepth === 0 && braceDepth === 0) {
                    for (const op of group) {
                        const len = op.length;
                        const sub = trimmed.substr(i, len);
                        if (sub === op) {
                            if (op === '+' || op === '-') {
                                const before = trimmed.substr(0, i).trim();
                                if (!before || /[\+\-\*\/\%\=\<\>\(\[\,\:]$/.test(before)) {
                                    continue;
                                }
                            }
                            if (op === 'or' || op === 'and') {
                                const beforeChar = i > 0 ? trimmed[i - 1] : ' ';
                                const afterChar = i + len < trimmed.length ? trimmed[i + len] : ' ';
                                if (/\w/.test(beforeChar) || /\w/.test(afterChar)) {
                                    continue;
                                }
                            }
                            if (op === '*' && (trimmed[i + 1] === '*' || trimmed[i - 1] === '*')) continue;
                            if (op === '/' && (trimmed[i + 1] === '/' || trimmed[i - 1] === '/')) continue;

                            return {
                                op,
                                left: trimmed.substring(0, i).trim(),
                                right: trimmed.substring(i + len).trim()
                            };
                        }
                    }
                }
            }
        }
    }
    return null;
}

function createValueBlock(workspace, valueStr) {
    if (!valueStr) return null;
    let str = String(valueStr).trim();
    str = unwrapOuterParens(str);

    // Check number
    if (/^-?\d+(\.\d+)?$/.test(str)) {
        const numBlock = createBlock(workspace, 'math_number', { NUM: str });
        if (numBlock) {
            numBlock.setFieldValue(str, 'NUM');
            return numBlock;
        }
    }

    // Check boolean
    if (str === 'True' || str === 'False') {
        const boolBlock = createBlock(workspace, 'python_boolean');
        if (boolBlock) {
            boolBlock.setFieldValue(str, 'BOOL');
            return boolBlock;
        }
    }

    // Check string literal (single or double quoted):
    if ((str.startsWith('"') && str.endsWith('"') && str.length >= 2) ||
        (str.startsWith("'") && str.endsWith("'") && str.length >= 2)) {
        const quoteChar = str[0];
        let isSingleString = true;
        for (let i = 1; i < str.length - 1; i++) {
            if (str[i] === quoteChar && str[i - 1] !== '\\') {
                isSingleString = false;
                break;
            }
        }
        if (isSingleString) {
            const raw = str.slice(1, -1);
            const strBlock = createBlock(workspace, 'text', { TEXT: raw });
            if (strBlock) {
                strBlock.setFieldValue(raw, 'TEXT');
                return strBlock;
            }
        }
    }

    // Check None
    if (str === 'None') {
        return createBlock(workspace, 'python_none');
    }

    // Check float(...)
    const toFloatVal = parseFuncCall('float', str);
    if (toFloatVal !== null) {
        const b = createBlock(workspace, 'python_cast_float');
        if (b) {
            attachInput(b, 'VAL', createValueBlock(workspace, toFloatVal));
            return b;
        }
    }

    // Check int(...)
    const toIntVal = parseFuncCall('int', str);
    if (toIntVal !== null) {
        const b = createBlock(workspace, 'python_cast_int');
        if (b) {
            attachInput(b, 'VAL', createValueBlock(workspace, toIntVal));
            return b;
        }
    }

    // Check str(...)
    const toStrVal = parseFuncCall('str', str);
    if (toStrVal !== null) {
        const b = createBlock(workspace, 'python_cast_str');
        if (b) {
            attachInput(b, 'VAL', createValueBlock(workspace, toStrVal));
            return b;
        }
    }

    // Check bool(...)
    const toBoolVal = parseFuncCall('bool', str);
    if (toBoolVal !== null) {
        const b = createBlock(workspace, 'python_cast_bool');
        if (b) {
            attachInput(b, 'VAL', createValueBlock(workspace, toBoolVal));
            return b;
        }
    }

    // Check round(...)
    const roundVal = parseFuncCall('round', str);
    if (roundVal !== null) {
        const b = createBlock(workspace, 'python_round');
        if (b) {
            attachInput(b, 'NUM', createValueBlock(workspace, roundVal));
            return b;
        }
    }

    // Check len(...)
    const lenVal = parseFuncCall('len', str);
    if (lenVal !== null) {
        const b = createBlock(workspace, 'python_list_len');
        if (b) {
            let listBlock;
            if (/^[A-Za-z_][A-Za-z0-9_]*$/.test(lenVal.trim())) {
                listBlock = createBlock(workspace, 'text');
                if (listBlock) listBlock.setFieldValue(lenVal.trim(), 'TEXT');
            } else {
                listBlock = createValueBlock(workspace, lenVal);
            }
            attachInput(b, 'LIST', listBlock);
            return b;
        }
    }

    // Check list indexing: list[index]
    const listGetMatch = str.match(/^([A-Za-z_][A-Za-z0-9_]*)\[(.*)\]$/);
    if (listGetMatch) {
        const listName = listGetMatch[1];
        const idxStr = listGetMatch[2].trim();
        const b = createBlock(workspace, 'python_list_get');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            attachInput(b, 'INDEX', createValueBlock(workspace, idxStr || '0'));
            return b;
        }
    }

    // Check type(...)
    const typeVal = parseFuncCall('type', str);
    if (typeVal !== null) {
        const b = createBlock(workspace, 'python_type');
        if (b) {
            attachInput(b, 'VAL', createValueBlock(workspace, typeVal));
            return b;
        }
    }

    // Check input(...)
    const inputVal = parseFuncCall('input', str);
    if (inputVal !== null) {
        const b = createBlock(workspace, 'python_input');
        if (b) {
            attachInput(b, 'PROMPT', createValueBlock(workspace, inputVal || '""'));
            return b;
        }
    }

    // Check top-level binary operations (and, or, comparisons, arithmetic)
    const binOp = findTopLevelBinaryOp(str);
    if (binOp) {
        if (binOp.op === 'and' || binOp.op === 'or') {
            const b = createBlock(workspace, 'python_bool_op');
            if (b) {
                b.setFieldValue(binOp.op, 'OP');
                attachInput(b, 'A', createValueBlock(workspace, binOp.left));
                attachInput(b, 'B', createValueBlock(workspace, binOp.right));
                return b;
            }
        } else if (['==', '!=', '<=', '>=', '<', '>'].includes(binOp.op)) {
            const b = createBlock(workspace, 'python_compare');
            if (b) {
                b.setFieldValue(binOp.op, 'OP');
                attachInput(b, 'A', createValueBlock(workspace, binOp.left));
                attachInput(b, 'B', createValueBlock(workspace, binOp.right));
                return b;
            }
        } else if (['+', '-', '*', '/', '//', '%', '**'].includes(binOp.op)) {
            const b = createBlock(workspace, 'python_arithmetic');
            if (b) {
                b.setFieldValue(binOp.op, 'OP');
                attachInput(b, 'A', createValueBlock(workspace, binOp.left));
                attachInput(b, 'B', createValueBlock(workspace, binOp.right));
                return b;
            }
        }
    }

    // Check unary negation: -x
    if (str.startsWith('-') && str.length > 1) {
        const b = createBlock(workspace, 'python_unary');
        if (b) {
            attachInput(b, 'NUM', createValueBlock(workspace, str.slice(1).trim()));
            return b;
        }
    }

    // Check variable identifier
    if (/^[A-Za-z_][A-Za-z0-9_]*$/.test(str)) {
        const varBlock = createBlock(workspace, 'python_variable_get', { VAR: str });
        if (varBlock) {
            return varBlock;
        }
    }

    // Fallback expression
    const rawBlock = createBlock(workspace, 'python_raw_expr');
    if (rawBlock) {
        rawBlock.setFieldValue(str, 'CODE');
        return rawBlock;
    }

    return null;
}

function attachInput(parentBlock, inputName, childBlock) {
    if (!parentBlock || !childBlock) return;
    const input = parentBlock.getInput(inputName);
    if (input && input.connection && childBlock.outputConnection) {
        input.connection.connect(childBlock.outputConnection);
        const isChildShadow = typeof childBlock.isShadow === 'function' && childBlock.isShadow();
        if (!isChildShadow) {
            const spec = getDefaultShadowSpec(parentBlock.type, inputName);
            if (spec && typeof input.connection.setShadowState === 'function') {
                try {
                    input.connection.setShadowState(spec);
                } catch (e) {
                    console.warn('Error setting shadow state:', e);
                }
            }
        }
    }
}

function attachSubstack(parentBlock, substackName, childBlock) {
    if (!parentBlock || !childBlock) return;
    const input = parentBlock.getInput(substackName);
    if (input && input.connection && childBlock.previousConnection) {
        input.connection.connect(childBlock.previousConnection);
    }
}

function connectNext(firstBlock, secondBlock) {
    if (!firstBlock || !secondBlock) return;
    if (firstBlock.nextConnection && secondBlock.previousConnection) {
        firstBlock.nextConnection.connect(secondBlock.previousConnection);
    }
}

/**
 * Parses Python lines with indentation hierarchy.
 */
function parseLines(lines) {
    const rootNodes = [];
    const stack = [{ indent: -1, children: rootNodes }];

    for (const rawLine of lines) {
        if (!rawLine.trim() || (rawLine.trim().startsWith('#') && !rawLine.trim().startsWith('# '))) {
            if (!rawLine.trim()) continue;
        }

        const indent = rawLine.search(/\S|$/);
        const text = rawLine.trim();

        const node = {
            text,
            indent,
            children: []
        };

        while (stack.length > 1 && stack[stack.length - 1].indent >= indent) {
            stack.pop();
        }

        stack[stack.length - 1].children.push(node);
        stack.push(node);
    }

    return rootNodes;
}

/**
 * Converts a node and its children into connected Blockly blocks.
 */
function nodeToBlock(workspace, node) {
    const text = node.text;

    // 1. Comments
    if (text.startsWith('#')) {
        const commentBlock = createBlock(workspace, 'python_comment');
        if (commentBlock) {
            commentBlock.setFieldValue(text.replace(/^#\s*/, ''), 'COMMENT');
            return commentBlock;
        }
    }

    // 2. print(...)
    const printMatch = text.match(/^print\((.*)\)$/);
    if (printMatch) {
        const inner = printMatch[1].trim();
        let args = splitArguments(inner);
        args = args.filter(a => !a.startsWith('end='));

        const printBlock = createBlock(workspace, 'python_print');
        if (printBlock) {
            if (args.length > 1 && typeof printBlock.setPartCount === 'function') {
                printBlock.setPartCount(args.length, true /* skipShadow */);
            }
            if (args.length === 0) {
                attachInput(printBlock, 'TEXT', createValueBlock(workspace, '""'));
            } else {
                args.forEach((arg, idx) => {
                    const inputName = idx === 0 ? 'TEXT' : ('TEXT' + idx);
                    attachInput(printBlock, inputName, createValueBlock(workspace, arg));
                });
            }
            return printBlock;
        }
    }

    // 3. Variables: set x = val
    const assignMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\s*=\s*(.+)$/);
    if (assignMatch) {
        const varName = assignMatch[1];
        const valStr = assignMatch[2];
        const setBlock = createBlock(workspace, 'python_variable_set', { VAR: varName });
        if (setBlock) {
            setVariableField(workspace, setBlock, 'VAR', varName);
            const valBlock = createValueBlock(workspace, valStr);
            attachInput(setBlock, 'VALUE', valBlock);
            return setBlock;
        }
    }

    // 4. Variables: x += val, -=, *=, /=
    const augAssignMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\s*([\+\-\*\/])=\s*(.+)$/);
    if (augAssignMatch) {
        const varName = augAssignMatch[1];
        const op = augAssignMatch[2];
        const valStr = augAssignMatch[3];
        const changeBlock = createBlock(workspace, 'python_variable_change', { VAR: varName, OP: op });
        if (changeBlock) {
            setVariableField(workspace, changeBlock, 'VAR', varName);
            changeBlock.setFieldValue(op, 'OP');
            const valBlock = createValueBlock(workspace, valStr);
            attachInput(changeBlock, 'VALUE', valBlock);
            return changeBlock;
        }
    }

    // 5. for i in range(start, stop[, step]):
    const forRangeMatch = text.match(/^for\s+([A-Za-z_][A-Za-z0-9_]*)\s+in\s+range\((.*)\):$/);
    if (forRangeMatch) {
        const varName = forRangeMatch[1];
        const args = splitArguments(forRangeMatch[2]);
        let forBlock;
        if (args.length >= 3) {
            forBlock = createBlock(workspace, 'python_for_range_step');
            if (forBlock) {
                forBlock.setFieldValue(varName, 'VAR');
                attachInput(forBlock, 'START', createValueBlock(workspace, args[0]));
                attachInput(forBlock, 'STOP', createValueBlock(workspace, args[1]));
                attachInput(forBlock, 'STEP', createValueBlock(workspace, args[2]));
            }
        } else {
            forBlock = createBlock(workspace, 'python_for_range');
            if (forBlock) {
                forBlock.setFieldValue(varName, 'VAR');
                if (args.length === 1) {
                    attachInput(forBlock, 'START', createValueBlock(workspace, '0'));
                    attachInput(forBlock, 'STOP', createValueBlock(workspace, args[0]));
                } else if (args.length >= 2) {
                    attachInput(forBlock, 'START', createValueBlock(workspace, args[0]));
                    attachInput(forBlock, 'STOP', createValueBlock(workspace, args[1]));
                }
            }
        }
        if (forBlock) {
            if (node.children.length > 0) {
                const subChain = nodesToBlockChain(workspace, node.children);
                attachSubstack(forBlock, 'SUBSTACK', subChain);
            }
            return forBlock;
        }
    }

    // 6. for item in list:
    const forInMatch = text.match(/^for\s+([A-Za-z_][A-Za-z0-9_]*)\s+in\s+(.+):$/);
    if (forInMatch) {
        const varName = forInMatch[1];
        const listStr = forInMatch[2].trim();
        const forBlock = createBlock(workspace, 'python_for_in');
        if (forBlock) {
            forBlock.setFieldValue(varName, 'VAR');
            let listBlock;
            if (/^[A-Za-z_][A-Za-z0-9_]*$/.test(listStr)) {
                listBlock = createBlock(workspace, 'text');
                if (listBlock) listBlock.setFieldValue(listStr, 'TEXT');
            } else {
                listBlock = createValueBlock(workspace, listStr);
            }
            attachInput(forBlock, 'LIST', listBlock);
            if (node.children.length > 0) {
                const subChain = nodesToBlockChain(workspace, node.children);
                attachSubstack(forBlock, 'SUBSTACK', subChain);
            }
            return forBlock;
        }
    }

    // 7. while condition:
    const whileMatch = text.match(/^while\s+(.+):$/);
    if (whileMatch) {
        const condStr = whileMatch[1];
        const whileBlock = createBlock(workspace, 'python_while');
        if (whileBlock) {
            attachInput(whileBlock, 'CONDITION', createValueBlock(workspace, condStr));
            if (node.children.length > 0) {
                const subChain = nodesToBlockChain(workspace, node.children);
                attachSubstack(whileBlock, 'SUBSTACK', subChain);
            }
            return whileBlock;
        }
    }

    // 8. if condition:
    const ifMatch = text.match(/^if\s+(.+):$/);
    if (ifMatch) {
        const condStr = ifMatch[1];
        const ifBlock = createBlock(workspace, 'python_if');
        if (ifBlock) {
            attachInput(ifBlock, 'CONDITION', createValueBlock(workspace, condStr));
            if (node.children.length > 0) {
                const subChain = nodesToBlockChain(workspace, node.children);
                attachSubstack(ifBlock, 'SUBSTACK', subChain);
            }
            return ifBlock;
        }
    }

    // 9. break / continue / pass
    if (text === 'break') return createBlock(workspace, 'python_break');
    if (text === 'continue') return createBlock(workspace, 'python_continue');
    if (text === 'pass') return createBlock(workspace, 'python_pass');

    // 10. def func():
    const defMatch = text.match(/^def\s+([A-Za-z_][A-Za-z0-9_]*)\((.*)\):$/);
    if (defMatch) {
        const funcName = defMatch[1];
        const args = splitArguments(defMatch[2]);
        let defBlock;
        if (args.length === 0) {
            defBlock = createBlock(workspace, 'python_def');
            if (defBlock) defBlock.setFieldValue(funcName, 'NAME');
        } else if (args.length === 1) {
            defBlock = createBlock(workspace, 'python_def_one_arg');
            if (defBlock) {
                defBlock.setFieldValue(funcName, 'NAME');
                defBlock.setFieldValue(args[0], 'ARG1');
            }
        } else {
            defBlock = createBlock(workspace, 'python_def_two_args');
            if (defBlock) {
                defBlock.setFieldValue(funcName, 'NAME');
                defBlock.setFieldValue(args[0], 'ARG1');
                defBlock.setFieldValue(args[1], 'ARG2');
            }
        }
        if (defBlock && node.children.length > 0) {
            const subChain = nodesToBlockChain(workspace, node.children);
            attachSubstack(defBlock, 'SUBSTACK', subChain);
        }
        return defBlock;
    }

    // 11. return val
    const returnMatch = text.match(/^return(\s+(.+))?$/);
    if (returnMatch) {
        const retBlock = createBlock(workspace, 'python_return');
        if (retBlock && returnMatch[2]) {
            attachInput(retBlock, 'VAL', createValueBlock(workspace, returnMatch[2].trim()));
        }
        return retBlock;
    }

    // 12. import statements
    const importAsMatch = text.match(/^import\s+([A-Za-z0-9_]+)\s+as\s+([A-Za-z0-9_]+)$/);
    if (importAsMatch) {
        const b = createBlock(workspace, 'python_import_as');
        if (b) {
            b.setFieldValue(importAsMatch[1], 'MODULE');
            b.setFieldValue(importAsMatch[2], 'ALIAS');
            return b;
        }
    }

    const importMatch = text.match(/^import\s+([A-Za-z0-9_]+)$/);
    if (importMatch) {
        const b = createBlock(workspace, 'python_import');
        if (b) {
            b.setFieldValue(importMatch[1], 'MODULE');
            return b;
        }
    }

    const fromImportMatch = text.match(/^from\s+([A-Za-z0-9_]+)\s+import\s+([A-Za-z0-9_]+)$/);
    if (fromImportMatch) {
        const b = createBlock(workspace, 'python_from_import');
        if (b) {
            b.setFieldValue(fromImportMatch[1], 'MODULE');
            b.setFieldValue(fromImportMatch[2], 'ITEM');
            return b;
        }
    }

    // List operations
    const appendMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\.append\((.*)\)$/);
    if (appendMatch) {
        const listName = appendMatch[1];
        const argStr = appendMatch[2].trim();
        const b = createBlock(workspace, 'python_list_append');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            attachInput(b, 'ITEM', createValueBlock(workspace, argStr || '0'));
            return b;
        }
    }

    const removeMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\.remove\((.*)\)$/);
    if (removeMatch) {
        const listName = removeMatch[1];
        const argStr = removeMatch[2].trim();
        const b = createBlock(workspace, 'python_list_remove');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            attachInput(b, 'ITEM', createValueBlock(workspace, argStr || '0'));
            return b;
        }
    }

    const insertMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\.insert\((.*)\)$/);
    if (insertMatch) {
        const listName = insertMatch[1];
        const args = splitArguments(insertMatch[2]);
        const b = createBlock(workspace, 'python_list_insert');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            attachInput(b, 'INDEX', createValueBlock(workspace, args[0] || '0'));
            attachInput(b, 'ITEM', createValueBlock(workspace, args[1] || '""'));
            return b;
        }
    }

    const popMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\.pop\((.*)\)$/);
    if (popMatch) {
        const listName = popMatch[1];
        const argStr = popMatch[2].trim();
        const b = createBlock(workspace, 'python_list_pop');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            if (argStr) {
                attachInput(b, 'INDEX', createValueBlock(workspace, argStr));
            }
            return b;
        }
    }

    const listSetMatch = text.match(/^([A-Za-z_][A-Za-z0-9_]*)\[(.*)\]\s*=\s*(.+)$/);
    if (listSetMatch) {
        const listName = listSetMatch[1];
        const idxStr = listSetMatch[2].trim();
        const valStr = listSetMatch[3].trim();
        const b = createBlock(workspace, 'python_list_set');
        if (b) {
            const listBlock = createBlock(workspace, 'text');
            if (listBlock) listBlock.setFieldValue(listName, 'TEXT');
            attachInput(b, 'LIST', listBlock);
            attachInput(b, 'INDEX', createValueBlock(workspace, idxStr || '0'));
            attachInput(b, 'VALUE', createValueBlock(workspace, valStr || '0'));
            return b;
        }
    }

    // 13. Fallback: python_raw
    const rawBlock = createBlock(workspace, 'python_raw');
    if (rawBlock) {
        rawBlock.setFieldValue(text, 'CODE');
        return rawBlock;
    }

    return null;
}

function nodesToBlockChain(workspace, nodes) {
    let firstBlock = null;
    let prevBlock = null;

    let i = 0;
    while (i < nodes.length) {
        const node = nodes[i];

        // Check if node is an if statement that may have subsequent elif/else blocks
        const ifMatch = node.text.match(/^if\s+(.+):$/);
        if (ifMatch) {
            const cond1 = ifMatch[1];
            const elifList = [];
            let hasElse = false;
            let elseNode = null;
            let consumed = 1;

            while (i + consumed < nodes.length) {
                const nextNode = nodes[i + consumed];
                const elifMatch = nextNode.text.match(/^elif\s+(.+):$/);
                if (elifMatch && !hasElse) {
                    elifList.push({ cond: elifMatch[1], node: nextNode });
                    consumed++;
                } else if (nextNode.text.match(/^else:$/) && !hasElse) {
                    hasElse = true;
                    elseNode = nextNode;
                    consumed++;
                    break;
                } else {
                    break;
                }
            }

            const ifBlock = createBlock(workspace, 'python_if');
            if (ifBlock) {
                if (typeof ifBlock.setElifAndElse === 'function') {
                    ifBlock.setElifAndElse(elifList.length, hasElse);
                } else {
                    ifBlock.elifCount_ = elifList.length;
                    ifBlock.hasElse_ = hasElse;
                    if (typeof ifBlock.rebuildShape_ === 'function') {
                        ifBlock.rebuildShape_();
                    }
                }

                attachInput(ifBlock, 'CONDITION', createValueBlock(workspace, cond1));
                attachSubstack(ifBlock, 'SUBSTACK', nodesToBlockChain(workspace, node.children));

                for (let k = 0; k < elifList.length; k++) {
                    attachInput(ifBlock, `CONDITION${k + 1}`, createValueBlock(workspace, elifList[k].cond));
                    attachSubstack(ifBlock, `SUBSTACK${k + 1}`, nodesToBlockChain(workspace, elifList[k].node.children));
                }

                if (hasElse && elseNode) {
                    attachSubstack(ifBlock, 'SUBSTACK_ELSE', nodesToBlockChain(workspace, elseNode.children));
                }

                if (!firstBlock) firstBlock = ifBlock;
                if (prevBlock) connectNext(prevBlock, ifBlock);
                prevBlock = ifBlock;
            }
            i += consumed;
            continue;
        }

        const block = nodeToBlock(workspace, node);
        if (block) {
            if (!firstBlock) {
                firstBlock = block;
            }
            if (prevBlock) {
                connectNext(prevBlock, block);
            }
            prevBlock = block;
        }
        i++;
    }

    return firstBlock;
}

function renderBlockRecursive(block) {
    if (!block) return;
    if (block.render) {
        block.render();
    }
    const inputList = block.inputList || [];
    for (const input of inputList) {
        if (input.connection && input.connection.targetBlock()) {
            renderBlockRecursive(input.connection.targetBlock());
        }
    }
    if (block.nextConnection && block.nextConnection.targetBlock()) {
        renderBlockRecursive(block.nextConnection.targetBlock());
    }
}

export function pythonToWorkspace(code, workspace) {
    if (!workspace) return false;

    const ScratchBlocks = (typeof window !== 'undefined' && window.ScratchBlocks) || (typeof window !== 'undefined' && window.Blockly);
    const eventsWereEnabled = ScratchBlocks &&
        ScratchBlocks.Events &&
        typeof ScratchBlocks.Events.isEnabled === 'function' &&
        ScratchBlocks.Events.isEnabled();

    if (eventsWereEnabled) {
        ScratchBlocks.Events.disable();
    }

    try {
        // Clear existing blocks
        if (workspace.clear) {
            workspace.clear();
        }

        const lines = (code || '').split(/\r?\n/);
        const rootNodes = parseLines(lines);
        if (rootNodes.length === 0) return true;

        const startX = 80;
        const startY = 50;

        const topBlock = nodesToBlockChain(workspace, rootNodes);

        if (typeof workspace.getAllBlocks === 'function') {
            const allBlocks = workspace.getAllBlocks(false);
            for (const b of allBlocks) {
                attachDefaultShadows(b);
            }
        }

        if (topBlock) {
            if (typeof topBlock.moveBy === 'function') { topBlock.moveBy(startX, startY); }
            renderBlockRecursive(topBlock);
        }

        // Clean up any unnecessary or invalid variables created during block instantiation
        const varMap = typeof workspace.getVariableMap === 'function' ? workspace.getVariableMap() : null;
        const canManageVars = varMap || (workspace.getAllVariables && workspace.deleteVariableById);
        if (canManageVars) {
            const usedVarNames = new Set();
            if (workspace.getAllBlocks) {
                const blocks = workspace.getAllBlocks(false);
                for (const b of blocks) {
                    if (b.type === 'python_variable_set' || b.type === 'python_variable_change') {
                        const field = b.getField('VAR');
                        const name = field ? field.getText() : null;
                        if (name && /^[A-Za-z_][A-Za-z0-9_]*$/.test(name)) {
                            usedVarNames.add(name);
                        }
                    } else if (b.type === 'python_variable_get') {
                        const field = b.getField('VAR');
                        const name = field ? field.getText() : b.getFieldValue('VAR');
                        if (name && /^[A-Za-z_][A-Za-z0-9_]*$/.test(name)) {
                            usedVarNames.add(name);
                        }
                    }
                }
            }

            const allVars = varMap && typeof varMap.getAllVariables === 'function'
                ? varMap.getAllVariables().slice()
                : (typeof workspace.getAllVariables === 'function' ? workspace.getAllVariables().slice() : []);
            for (const v of allVars) {
                if (!v.name || !/^[A-Za-z_][A-Za-z0-9_]*$/.test(v.name) || (usedVarNames.size > 0 && !usedVarNames.has(v.name))) {
                    try {
                        if (varMap && typeof varMap.deleteVariable === 'function') {
                            varMap.deleteVariable(v);
                        } else if (typeof workspace.deleteVariableById === 'function') {
                            workspace.deleteVariableById(v.getId());
                        }
                    } catch (e) {}
                }
            }
        }

        if (workspace.render) {
            workspace.render();
        }
        if (typeof window !== 'undefined' && window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('pixelblock:workspaceChange'));
        }

        return true;
    } finally {
        if (eventsWereEnabled) {
            ScratchBlocks.Events.enable();
        }
    }
}
